export default __webpack_public_path__ + "static/media/you-1.7e3a9afd.svg";